import { post, upload } from './http'

// 刷新接口
export const AlbumBannertestRandom = (p) => post('/AlbumBanner/testRandom', p)// 获取文件夹目录


// 文件夹模块接口
export const Adminalbumdirectoryget = (p) => post('/Adminalbumdirectory/get', p)// 获取文件夹目录
export const Adminalbumdirectoryadd = (p) => post('/Adminalbumdirectory/add', p)// 添加文件夹目录
export const Adminalbumdirectorydel = (p) => post('/Adminalbumdirectory/del', p)// 删除文件夹目录
export const Adminalbumdirectoryedit = (p) => post('/Adminalbumdirectory/edit', p)// 编辑文件夹目录
export const Adminalbumdirectoryexchange = (p) => post('/Adminalbumdirectory/exchange', p)// 文件夹对调
export const Adminalbumdirectorymove = (p) => post('/Adminalbumdirectory/move', p)// 移动文件夹目录
export const Adminalbumdigetinfo = (p) => post('/Adminalbumdirectory/getinfo', p)// 移动文件夹目录


// 图片模块接口
export const Adminalbumpicupload = (p) => upload('/Adminalbumpic/upload', p)// 上传图片到服务器
export const Adminalbumpicgetlist = (p) => post('/Adminalbumpic/getlist', p)// 获取图片
export const Adminalbumpicdel = (p) => post('/Adminalbumpic/del', p)// 删除图片
export const Adminalbumpicsave = (p) => post('/Adminalbumpic/save', p)// 保存图片
export const Adminalbumpicexchange = (p) => post('/Adminalbumpic/exchange', p)// 对调图片
export const Adminalbumpicmove = (p) => post('/Adminalbumpic/move', p)// 移动图片
export const AlbumPicgetlist = (p) => post('/AlbumPic/getlist', p)// 获取图片
export const AlbumweixingetMedia = (p) => post('/Albumweixin/uploadMedia', p)// 获取图片


// 微信模块接口
export const Albumweixinsignature = (p) => post('/Albumweixin/signature', p)// 微信js
export const Userthird = (p) => post('/User/third', p)// 微信登录


// 广告模块接口
export const getlist = (p) => post('/AlbumBanner/getlist', p)// 获取广告列表


// 分类模块接口
export const getShowDir = (p) => post('/Albumdirectory/getShowDir', p)// 获取首页显示的目录
export const getDir = (p) => post('/Albumdirectory/getDir', p)// 获取目录列表
export const getIndexDir = (p) => post('/Albumdirectory/getIndexDir', p)// 获取首页推荐目录的图片


// 会员模块接口
export const Albumlevelgetlist = (p) => post('/Albumlevel/getlist', p)// 获取目录列表
export const Albumlevelgetinfo = (p) => post('/Albumlevel/getinfo', p)// 获取会员等级的信息


// 订单模块接口
export const doneKeepOrder = (p) => post('/Albumorder/doneKeepOrder', p)// 添加续费订单
export const doneOrder = (p) => post('/Albumorder/doneOrder', p)// 添加续费订单
export const AlbumorderdoneAccountOrder = (p) => post('/Albumorder/doneAccountOrder', p)// 添加开通账号订单
export const AlbumdonekeepAccountOrder = (p) => post('/Albumorder/donekeepAccountOrder', p)// 添加开通会员订单


// 画册模块接口
export const Albumgetinfo = (p) => post('/Album/getinfo', p)// 获取画册基本信息
export const Albumsave = (p) => post('/Album/save', p)// 保存画册信息
export const changePassword = (p) => post('/Album/changePassword', p)// 修改密码
export const Albumlogin = (p) => post('/Album/login', p)// 画册登录
export const AlbumgetBaseInfo = (p) => post('/Album/getBaseInfo', p)// 获取画册的基本信息（无须登录）


// 支付模块接口
export const Albumpaypay = (p) => post('/Albumpay/pay', p)// 修改密码


// 视频模块接口
export const Albumvideogetlist = (p) => post('/Albumvideo/getlist', p)// 修改密码


// 换图场景
export const Albumsencegetlist = (p) => post('/Albumsence/getlist', p)// 换图场景
export const AlbumframegetFrame = (p) => post('/Albumframe/getFrame', p)// 获取边框列表
export const AlbumsencegetUrl = (p) => post('/Albumsence/getUrl', p)// base图片转url


// 画册模块
export const AlbumsenopenAccount = (p) => post('/Album/openAccount', p)// 开通账号


// 后台接口
export const Albumpcgetlist = (p) => post('/Albumpc/getlist', p)// 获取会员的等级列表
export const AlbumpcdoneOrder = (p) => post('/Albumpc/doneOrder', p)// 获取会员的等级列表

//分类接口
export const AlbumframegetEffectFrame = (p) => post('/Albumframe/getEffectFrame', p)// 获取分类列表接口
